function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#9d5025",
  d: "M19.64 22.51L16 24.32v51.36l3.64 1.81 14.34-26.42-14.34-28.56zM30.72 31.78l5.36-7.59L60.1 34.87l-5.6.89-23.78-3.98zM26.56 68.77l5.9 8.11L60.1 64.95l-5.34-.83-28.2 4.65z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f58536",
  d: "M28.12 75.5l-8.48 1.99V22.51l8.48 1.93V75.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#9d5025",
  d: "M23.66 20.5l4.46-2.23 8.4 35.29-8.4 28.17-4.46-2.23v-59zM54.46 64.08l5.64.87 5.16-14.37-5.16-15.71-5.64.89v28.32z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#f58536",
  d: "M36.8 79.28l-8.68 2.45V18.27l8.68 2.46v58.55z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#f58536",
  d: "M66.01 63.84l-37.89 7.04v10.85l37.89-10.7v-7.19zM66.08 36l-37.96-7.21V18.27l37.96 10.77V36z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#f58536",
  d: "M60.1 27.34l6.09 1.68v42.01L60.1 72.7V27.34z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#6b3a19",
  d: "M84 44.45l-16.3.77-5.76-.39 16.48-13.28L84 44.45z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#9d5025",
  d: "M61.94 44.83l16.48-.93V31.55l-16.48 2.67v10.61z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#6b3a19",
  d: "M46.43 43.79l16.7-16.83 8.49 16.26-17.31 1.1-7.88-.53z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#9d5025",
  d: "M46.43 43.79l16.7-1.42V26.96l-16.7 3.91v12.92zM61.94 55.39l22.06.38-5.58 12.9L61.94 66V55.39z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#9d5025",
  d: "M46.43 56.43l25.19.58-8.49 16.25-16.7-3.9V56.43z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#fbbf93",
  d: "M46.43 56.43l16.7 1.43 8.49-.85-17.31-1.11-7.88.53zM84 55.77l-16.3-.76-5.76.38 16.48.94 5.58-.56z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#f58536",
  d: "M78.42 43.9l5.58.55V33.22l-5.58-1.67V43.9zM71.62 43.22l-8.49-.85V26.96l8.49 2.55v13.71zM78.42 56.33l5.58-.56V67l-5.58 1.67V56.33zM71.62 57.01l-8.49.85v15.4l8.49-2.54V57.01z"
});

function SvgEcslogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: 100,
    height: 100
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

export default __webpack_public_path__ + "ecs.logo.83b41.svg";
export { SvgEcslogo as ReactComponent };